import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useProceedingAddNewAlias } from '@/module/Author/Proceeding/model/ProceedingQuery';
import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { proceedingMembershipOptions } from '@/module/Nomen/ProceedingMembership/model/ProceedingMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function ProceedingSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(proceedingMembershipOptions.getAll());

  const mutation = useProceedingAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { proceedingId: publicationId, request: request },
      {
        onSuccess: proceeding => {
          notification.success();
          navigate({ to: '/author/proceeding/$proceedingId', params: { proceedingId: String(proceeding.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
